
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { SectionTitle } from "@/components/SectionTitle";
import { PageTitle } from "@/components/PageTitle";

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <PageTitle title="Privacy Policy – Asrani Dental Clinic" />
      <Header />
      <main className="flex-grow">
        <div className="container-custom py-12 md:py-16">
          <SectionTitle
            title="Privacy Policy"
            subtitle="Last Updated: May, 2023"
            alignment="left"
          />
          
          <div className="prose prose-lg max-w-none mt-8">
            <p className="text-gray-600">
              This Privacy Policy explains how Asrani Dental Clinic ("we", "us", or "our") collects, uses, and shares your personal information when you visit our website, use our services, or otherwise interact with us.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Information We Collect</h2>
            
            <p className="text-gray-600">
              When you visit our website or use our services, we may collect certain information about you, including:
            </p>
            
            <ul className="list-disc ml-6 text-gray-600 space-y-2 mt-4">
              <li><strong>Personal Information:</strong> Such as your name, email address, phone number, and address when you fill out forms on our website or schedule an appointment.</li>
              <li><strong>Medical Information:</strong> Such as your dental history, treatment records, and insurance information.</li>
              <li><strong>Usage Information:</strong> Information about how you use our website, including your IP address, browser type, device information, pages visited, and time spent on those pages.</li>
              <li><strong>Communications:</strong> Records of correspondence if you contact us by email, phone, or other means.</li>
            </ul>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">How We Use Your Information</h2>
            
            <p className="text-gray-600">
              We use the information we collect to:
            </p>
            
            <ul className="list-disc ml-6 text-gray-600 space-y-2 mt-4">
              <li>Provide, maintain, and improve our dental services</li>
              <li>Process and manage your appointments</li>
              <li>Communicate with you about your treatment, appointments, and our services</li>
              <li>Send you appointment reminders, health information, and marketing communications (with your consent)</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Comply with legal obligations and protect our rights</li>
            </ul>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Information Sharing and Disclosure</h2>
            
            <p className="text-gray-600">
              We may share your information with:
            </p>
            
            <ul className="list-disc ml-6 text-gray-600 space-y-2 mt-4">
              <li><strong>Healthcare Providers:</strong> Other dental professionals who are involved in your care.</li>
              <li><strong>Insurance Companies:</strong> To process claims and payments.</li>
              <li><strong>Service Providers:</strong> Third-party vendors who help us operate our website and provide our services.</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights.</li>
            </ul>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Data Security</h2>
            
            <p className="text-gray-600">
              We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Your Rights</h2>
            
            <p className="text-gray-600">
              Depending on your location, you may have certain rights regarding your personal information, such as the right to:
            </p>
            
            <ul className="list-disc ml-6 text-gray-600 space-y-2 mt-4">
              <li>Access and receive a copy of your personal information</li>
              <li>Correct inaccurate personal information</li>
              <li>Request deletion of your personal information</li>
              <li>Object to or restrict the processing of your personal information</li>
              <li>Data portability</li>
            </ul>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Contact Us</h2>
            
            <p className="text-gray-600">
              If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
            </p>
            
            <p className="text-gray-600 mt-4">
              <strong>Asrani Dental Clinic</strong><br />
              Email: asranisbdental@gmail.com<br />
              Phone: +91 8010224989
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
